import { Deal, DealFilter } from '@spilca/order_ts/v1/order/model_deal_pb';
import {
  int64,
  fillFilterParam,
  convertDateRange,
  string,
  boolean
} from '@monorepo/helpers';
import { productFilterConstructor } from '@monorepo/orders';
import { FILTER_PARAMS } from '@monorepo/dictionary';
import dealConditionFilterConstructor from '../dealConditionFilterConstructor';

const dealsFilterConstructor = (
  filterValues: any,
  activeFilter: string | null
): DealFilter => {
  const filter = new DealFilter();
  if (filterValues[FILTER_PARAMS.offerId]) {
    filter.setOfferId(int64(filterValues[FILTER_PARAMS.offerId]));
  }

  if (filterValues[FILTER_PARAMS.multiDealId]) {
    filter.setMultiDealId(int64(filterValues[FILTER_PARAMS.multiDealId]));
  }

  if (filterValues[FILTER_PARAMS.updatedDate]) {
    const [start, end] = fillFilterParam(
      activeFilter,
      FILTER_PARAMS.updatedDate,
      filterValues
    );
    filter.setUpdated(convertDateRange(start, end));
  }

  if (filterValues[FILTER_PARAMS.createdDate]) {
    const [start, end] = fillFilterParam(
      activeFilter,
      FILTER_PARAMS.createdDate,
      filterValues
    );
    filter.setCreated(convertDateRange(start, end));
  }

  if (filterValues[FILTER_PARAMS.hasSupplier]) {
    const val = filterValues[FILTER_PARAMS.hasSupplier].toString();

    if (val === 'all') {
      filter.setHasSupplier();
    }
    if (val === 'on') {
      filter.setHasSupplier(boolean(true));
    }
    if (val === 'off') {
      filter.setHasSupplier(boolean(false));
    }
  }

  if (filterValues[FILTER_PARAMS.status]) {
    const st = new Deal.StatusValue();
    st.setValue(
      fillFilterParam(activeFilter, FILTER_PARAMS.status, filterValues)
    );
    filter.setStatus(st);
  }

  filter.setConditionFilter(
    dealConditionFilterConstructor({
      deliveryConditionList: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.deliveryCondition,
        filterValues
      ),
      paymentConditionList: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.paymentCondition,
        filterValues
      ),
      paymentDate: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.paymentDate,
        filterValues
      ),
      deliveryDate: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.deliveryDate,
        filterValues
      ),
      expiredDate: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.expiredDate,
        filterValues
      )
    })
  );

  filter.setProductFilter(
    productFilterConstructor({
      categoryIdList: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.cultureId,
        filterValues
      ),
      typeList: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.typeId,
        filterValues
      ),
      brandIdList: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.brandId,
        filterValues
      ),
      idList: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.productId,
        filterValues
      ),
      quantityTypeIdList: fillFilterParam(
        activeFilter,
        FILTER_PARAMS.quantityType,
        filterValues
      )
    })
  );

  if (filterValues[FILTER_PARAMS.farmerId]) {
    filter.setOrderCreator(string(filterValues[FILTER_PARAMS.farmerId]));
  }

  if (filterValues[FILTER_PARAMS.id]) {
    filter.setExternalId(string(filterValues[FILTER_PARAMS.id].toString()));
  }

  return filter;
};

export default dealsFilterConstructor;
